import { ServerPermission } from '../enums/server-permission.enum';
import { UserStatus } from '../enums/user-status.enum';

export const ACCOUNT_PERMISSIONS_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.account.permissions.v2+json';

export class AccountPermissions {
  public accountId: string;
  public realmId: string;
  public status: UserStatus;
  public permissions: ServerPermission[];

  constructor(backEndPermissions?: BackEndAccountPermissions) {
    if (backEndPermissions) {
      this.accountId = backEndPermissions.account_id;
      this.realmId = backEndPermissions.realm_id;
      this.status = backEndPermissions.status;
      this.permissions = backEndPermissions.permissions;
    }
  }

  public toBackEnd(): BackEndAccountPermissions {
    return {
      account_id: this.accountId,
      realm_id: this.realmId,
      status: this.status,
      permissions: this.permissions,
    };
  }

  /**
   * Does this account have a particular server permission?
   * @param perm The permission to check
   */
   public hasPermission(perm: ServerPermission): boolean {
    return this.permissions.includes(perm);
  }

  public static permissionsEqual(set1: ServerPermission[], set2: ServerPermission[]) {
    // Either falsy
    if (!set1 || !set2) {
      return set1 === set2;
    }

    // Same length
    if (set1.length !== set2.length) {
      return false;
    }

    // Same contents, in any order
    for (const p of set1) {
      if (!set2.includes(p)) {
        return false;
      }
    }
    return true;
  }
}

export interface BackEndAccountPermissions {
  account_id: string;
  realm_id: string;
  status: UserStatus;
  permissions: ServerPermission[];
}
